import Loadable from 'react-loadable';
import React from 'react';
import { timeInterfaceName } from '@bit/evidation.sdf1.fields.time';
import { validations as datetime_validations } from '@bit/evidation.sdf1.fields.datetime';
import { validations as mask_custom_validations } from '@bit/evidation.sdf1.fields.mask_custom';

const Loading = props => {
  if (props.error) {
    return (
      <div>
        Error! <button onClick={props.retry}>Retry</button>
      </div>
    );
  } else if (props.pastDelay) {
    return <div>Loading...</div>;
  } else {
    return null;
  }
};

const load = (loader, loading = Loading) =>
  Loadable({ loader, loading, delay: 500 });

const email_confirm = load(() =>
  import('@bit/evidation.sdf1.studies.email_confirm'),
);
const selectnumberrange = load(() =>
  import('@bit/evidation.sdf1.studies.select-number-range'),
);
const time = load(() => import('@bit/evidation.sdf1.fields.time'));
const datetime = load(() => import('@bit/evidation.sdf1.fields.datetime'));
const mask_custom = load(() =>
  import('@bit/evidation.sdf1.fields.mask_custom'),
);

export default {
  field: {
    [timeInterfaceName]: time,
    datetime: {
      component: datetime,
      validations: datetime_validations,
    },
    mask_custom: {
      component: mask_custom,
      validations: mask_custom_validations,
    },
  },
  raw: {
    email_confirm,
    'select-number-range': selectnumberrange,
  },
};



// WEBPACK FOOTER //
// ./src/components/componentDictionary.js